export default __webpack_public_path__ + "static/media/FitnessTracker.d2a2e744.gif";